import tmpl from 'templates/api_keys_list';
import Base from 'app/views/base';
import ApiKeys from 'app/collections/api_keys';
import ApiKeysListItemView from 'app/views/api_keys_list_item_view';
import CreateApiKeyModal from 'app/views/modals/create_api_key_modal';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .create-new': 'createNewKey',
  },

  initialize() {
    this.collection = new ApiKeys([], {});
    this.listenTo(this.collection, 'sync change', this.render);
    this.collection.fetch();
    this.createApiKeyModal = new CreateApiKeyModal({ collection: this.collection });
  },

  beforeRender() {
    this.removeSubviews();

    this.collection.each((apiKey) => {
      this.addSubview(`apiKey_${apiKey.get('key')}`, `#apiKey_${apiKey.get('key')}`, new ApiKeysListItemView({ model: apiKey }));
    }, this);
  },

  context() {
    return {
      prodApiKeys: this.collection.where({ mode: 'production' }).map(key => key.toJSON()),
      testApiKeys: this.collection.where({ mode: 'test' }).map(key => key.toJSON()),
    };
  },

  createNewKey() {
    this.createApiKeyModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/api_keys_list_view.js